import { gql } from "@apollo/client";

export const GET_EQUIPMENT_REQUESTS_BY_STATUS = gql`
    query equipmentRequestsByStatus($status: String!) {
        equipmentRequestsByStatus(status: $status) {
            id
            job {
                name
            }
            status
            datetimeCreated
            requestedBy {
                firstName
                lastName
            }
            equipmentRequestItemsForEquipmentRequest {
                id
            }
        }
    }
`

export const GET_EQUIPMENT_REQUEST_BY_ID_WITH_INFO = gql`
    query equipmentRequest($id: Int!) {
        equipmentRequest(id: $id) {
            notes
            job {
                name
            }
            truck {
                number
            }
            datetimeCreated
            status
            datetimeFulfilled

        }
    }
`

export const GET_EQUIPMENT_REQUEST_BY_ID_WITH_ITEMS = gql`
    query equipmentRequest($id: Int!) {
        equipmentRequest(id: $id) {

            equipmentRequestItemsForEquipmentRequest {
                id
                equipment {
                    sku
                    name
                    description
                }
                requestedQuantity
                sentQuantity
                
            }
        }
    }
`